"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var FlexVideoComponent = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
      banner = props.banner,
      sharp = props.sharp,
      radius = props.radius,
      source = props.source,
      className = props.className,
      href = props.href,
      children = props.children,
      onClick = props.onClick,
      height = props.height,
      width = props.width,
      style = props.style,
      postMessageUrl = props.postMessageUrl,
      restProps = __rest(props, ["icon", "banner", "sharp", "radius", "source", "className", "href", "children", "onClick", "height", "width", "style", "postMessageUrl"]);

  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref
  }, restProps), /*#__PURE__*/_react["default"].createElement("iframe", {
    id: "frame_child_content",
    width: "0",
    height: "0",
    className: 'flex-video-default-class',
    src: postMessageUrl || 'https://intl.cloud.tencent.com/solution-new/tcp-player'
  }));
});
FlexVideoComponent.displayName = 'TCIFlexVideo';
var _default = FlexVideoComponent;
exports["default"] = _default;